const mobileMenu  = () => {
    const mainBtns = document.querySelector('.header-main-btns'),
          headerTop = mainBtns.parentElement.parentElement.parentElement.parentElement,
          mainBtnsLocation =  headerTop.children[0].children[0].children[1],
          hamburger = document.querySelector('.hamburger'),
          mobileMenu = document.querySelector('.header-mobile'),
          closeBtn = document.querySelector('.header-mobile__close'),
          currencyDropdown = document.querySelector('#currency').parentElement,
          languageDropdown = document.querySelector('#lang').parentElement,
          currencyPlace = document.querySelector('.header-mobile-currency'),
          languagePlace = document.querySelector('.header-mobile-language'),
          dropdownOriginalPlace = currencyDropdown.parentElement,
          headerContacts = document.querySelector('.header-contacts'),
          headerContactsOriginalPlace = headerContacts.parentElement,
          headerMobileContacts = document.querySelector('.header-mobile__contacts'),
          headerNav = document.querySelector('.header__nav'),
          headerNavOriginalPlace = headerNav.nextElementSibling,
          headerNavPlace = document.querySelector('.header-mobile__nav'),
          catalog = document.querySelector('.catalog'),
          catalogOriginalPlace = catalog.parentElement,
          catalogLink = document.querySelector('#catalog'),
          subMenuLink = document.querySelectorAll('.catalog-item__title');






    window.addEventListener('resize', () => {
        if(document.documentElement.clientWidth <=768) {
            generateMobileMenu();
        } else {
            generateDesktopMenu()
            mobileMenu.style.display = 'none';
        }
    })

    hamburger.addEventListener('click', () => {
        mobileMenu.style.display = 'block';
    })
    closeBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'none';
    })
    function generateMobileMenu() {
        const menu = document.querySelector('.header-b-block ');
        headerTop.style.display = 'none';
        menu.appendChild(mainBtns);
        currencyPlace.appendChild(currencyDropdown);
        languagePlace.appendChild(languageDropdown);
        headerMobileContacts.appendChild(headerContacts);
        headerNavPlace.appendChild(headerNav);
        catalogLink.appendChild(catalog);
        
    }
 
    function generateDesktopMenu() {
        headerTop.style.display = 'block';
        mainBtnsLocation.appendChild(mainBtns);
        dropdownOriginalPlace.appendChild(currencyDropdown);
        dropdownOriginalPlace.appendChild(languageDropdown);
        headerContactsOriginalPlace.insertAdjacentElement('afterbegin', headerContacts);
        headerNavOriginalPlace.insertAdjacentElement('beforebegin', headerNav);
        catalogOriginalPlace.appendChild(catalog);
    }
    if(document.documentElement.clientWidth <=768) {
        generateMobileMenu();
        let executive = true;
        catalogLink.addEventListener('click', (e) => {
            if(document.documentElement.clientWidth <=768) {
                if(e.target.id === 'catalog' || e.target.parentElement.id === 'catalog') {
                    catalogLink.classList.toggle('rotate');
                    if(executive) {
                        catalog.style.display = 'block';
                        catalog.style.opacity = '1';
                        
                        return executive = false;
                    } else {
                        catalog.style.display = 'none';
                        catalog.style.opacity = '0';
                        return executive = true;
                    }
                }
            }
        })
        subMenuLink.forEach(item => {
            let executive = true
            item.addEventListener('click', () => {
                if(document.documentElement.clientWidth <=768) {
                    item.classList.toggle('rotate');
                    if(executive) {
                        item.parentElement.nextElementSibling.style.display = 'block';
                        return executive = false;
                    } else {
                        item.parentElement.nextElementSibling.style.display = 'none';
                        return executive = true;
                    }
                    
                 }
                
                
            })
        })
    } else {
        generateDesktopMenu()
    }
    document.addEventListener('click', (e) => {
        function isDescendant(parent, child) {
            var node = child.parentNode;
            while (node != null) {
                if (node == parent) {
                    return false;
                }
                node = node.parentNode;
            }
            return true;
       }
       if(isDescendant(mobileMenu, e.target) && !e.target.classList.contains('hamburger') && !e.target.classList.contains('header-mobile') && !e.target.parentElement.classList.contains('hamburger')) {
            mobileMenu.style.display = 'none';
       }
       
    })
}

export default mobileMenu;